<script setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import SidenavItem from "./SidenavItem.vue";
import { useAuth } from "@/composables/useAuth";
import { ROLES } from "@/constants/roles";
const openMenu = ref(null);
const store = useStore();
const isRTL = computed(() => store.state.isRTL);


const { user } = useAuth();
const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

const toggleMenu = (menu) => {
  openMenu.value = openMenu.value === menu ? null : menu;
};


const router = useRouter();
const { logout: logoutAuth } = useAuth();

const logout = async () => {
  await logoutAuth(); // 🔐 invalida el refresh token en el backend y limpia la cookie
  router.push("/signin"); // 🔄 redirige
};


</script>


<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item to="/dashboard" :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="isRTL ? 'لوحة القيادة' : 'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user?.role === 'admin'" class="mt-3 nav-item">
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          صفحات المرافق
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Cotizaciones
        </h6>
      </li>

      <li class="nav-item">
        <!-- ITEM PADRE -->


        <div class="nav-link d-flex justify-content-between align-items-center cursor-pointer"
          @click="toggleMenu('quotation')" style=" margin-left: 17px;">
          <div class="d-flex align-items-center">
            <i class="ni ni-books text-success text-sm opacity-10 me-2"></i>
            <span class="nav-link-text" :class="isRTL ? 'me-1' : 'ms-1'">
              {{ isRTL ? 'الجداول' : 'Cotizaciones' }}
            </span>
          </div>

          <i class="ni" :class="openMenu === 'quotation' ? 'ni-bold-up' : 'ni-bold-down'"></i>
        </div>

        <!-- SUBMENÚ -->
        <ul v-if="openMenu === 'quotation'" class="nav flex-column ms-4">

          <li class="nav-item">
            <sidenav-item to="/quote/create" navText="Cotizacion">
              <template v-slot:icon>
                <i class="ni ni-align-center text-success text-sm"></i>
              </template>
            </sidenav-item>
          </li>

          <li class="nav-item" v-if="[ROLES.ADMIN, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO].includes(user?.role)">
            <sidenav-item to="/quote/corp" navText="Cotizacion Corporativo">
              <template v-slot:icon>
                <i class="ni ni-single-copy-04 text-success text-sm"></i>
              </template>
            </sidenav-item>
          </li>

          <li class="nav-item">
            <sidenav-item to="/quote/manual" navText="Cotizacion Manual">
              <template v-slot:icon>
                <i class="ni ni-ruler-pencil text-success text-sm"></i>
              </template>
            </sidenav-item>
          </li>

          <li class="nav-item">
            <sidenav-item to="/quote/list" navText="Mis Cotizaciones">
              <template v-slot:icon>
                <i class="ni ni-bullet-list-67 text-success text-sm"></i>
              </template>
            </sidenav-item>
          </li>

          <li class="nav-item">
            <sidenav-item to="/quote/buscador" navText="Buscador Cotizaciones">
              <template v-slot:icon>
                <i class="ni ni-zoom-split-in text-success text-sm"></i>
              </template>
            </sidenav-item>
          </li>

        </ul>
      </li>





      <li v-if="[ROLES.ADMIN, ROLES.SUPERVISOR, ROLES.RRHH].includes(user?.role)" class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Kommo
        </h6>
      </li>

      <li v-if="[ROLES.ADMIN, ROLES.SUPERVISOR, ROLES.RRHH].includes(user?.role)" class="nav-item">
        <sidenav-item to="/kommo/sin-respuesta" :class="getRoute() === 'kommo' ? 'active' : ''"
          navText="Clientes sin respuesta">
          <template v-slot:icon>
            <i class="ni ni-chat-round text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="[ROLES.ADMIN, ROLES.SUPERVISOR].includes(user?.role)" class="mt-3 nav-item">
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          صفحات المرافق
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Reportes
        </h6>
      </li>

      <li v-if="[ROLES.ADMIN, ROLES.SUPERVISOR].includes(user?.role)" class="nav-item">
        <sidenav-item to="/billing" :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Generar'">
          <template v-slot:icon>
            <i class="ni ni-chart-bar-32 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user?.role === 'admin' || user?.role === 'contabilidad'" class="mt-3 nav-item">
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          صفحات المرافق
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Contabilidad
        </h6>
      </li>

      <li v-if="user?.role === 'admin' || user?.role === 'contabilidad'" class="nav-item">
        <sidenav-item to="/contabilidad" :class="getRoute() === 'contabilidad' ? 'active' : ''"
          navText="Contabilidad">
          <template v-slot:icon>
            <i class="ni ni-money-coins text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li
        v-if="[ROLES.ADMIN, ROLES.ASESOR, ROLES.ASESOR_CHAT, ROLES.ASESOR_LIDER, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.RRHH].includes(user?.role)"
        class="mt-3 nav-item"
      >
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          صفحات المرافق
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Citas
        </h6>
      </li>

      <li v-if="[ROLES.ADMIN, ROLES.ASESOR, ROLES.ASESOR_CHAT, ROLES.ASESOR_LIDER, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.RRHH].includes(user?.role)" class="nav-item">
        <sidenav-item to="/citas/agendar" :class="getRoute() === 'citas' ? 'active' : ''" navText="Agendar Cita">
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="[ROLES.ADMIN, ROLES.ASESOR, ROLES.ASESOR_CHAT, ROLES.ASESOR_LIDER, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.RRHH, ROLES.SUPERVISOR].includes(user?.role)" class="nav-item">
        <sidenav-item to="/citas/calendario" :class="getRoute() === 'citas' ? 'active' : ''" navText="Calendario de Citas">
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="[ROLES.ADMIN, ROLES.ASESOR, ROLES.ASESOR_CHAT, ROLES.ASESOR_LIDER, ROLES.ASESOR_CORPORATIVO, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.RRHH].includes(user?.role)" class="nav-item">
        <sidenav-item to="/citas/mis-citas" :class="getRoute() === 'citas' ? 'active' : ''" navText="Mis Citas">
          <template v-slot:icon>
            <i class="ni ni-collection text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="[ROLES.ADMIN, ROLES.ASESOR_LIDER, ROLES.ASESOR_LIDER_CORPORATIVO, ROLES.SUPERVISOR, ROLES.RRHH].includes(user?.role)" class="nav-item">
        <sidenav-item to="/citas/horario" :class="getRoute() === 'citas' ? 'active' : ''" navText="Mi Horario">
          <template v-slot:icon>
            <i class="ni ni-time-alarm text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user" class="mt-3 nav-item">
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          صفحات المرافق
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Recursos Humanos
        </h6>
      </li>

      <li v-if="user" class="nav-item">
        <sidenav-item to="/rrhh/empleados" :class="getRoute() === 'rrhh' ? 'active' : ''"
          navText="Empleados">
          <template v-slot:icon>
            <i class="ni ni-badge text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user" class="nav-item">
        <sidenav-item to="/rrhh/mi-expediente" :class="getRoute() === 'rrhh' ? 'active' : ''"
          navText="Mi Expediente">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user" class="nav-item">
        <sidenav-item to="/rrhh/mis-solicitudes" :class="getRoute() === 'rrhh' ? 'active' : ''"
          navText="Mis Solicitudes">
          <template v-slot:icon>
            <i class="ni ni-collection text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user" class="nav-item">
        <sidenav-item to="/rrhh/calendario" :class="getRoute() === 'rrhh' ? 'active' : ''"
          navText="Calendario RRHH">
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user" class="nav-item">
        <sidenav-item to="/rrhh/organigrama" :class="getRoute() === 'rrhh' ? 'active' : ''"
          navText="Organigrama">
          <template v-slot:icon>
            <i class="ni ni-world-2 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user" class="nav-item">
        <sidenav-item to="/rrhh/aprobaciones" :class="getRoute() === 'rrhh' ? 'active' : ''"
          navText="Aprobaciones">
          <template v-slot:icon>
            <i class="ni ni-check-bold text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user?.role === ROLES.ADMIN || user?.role === ROLES.SUPERVISOR" class="mt-3 nav-item">
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          صفحات المرافق
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Configuraciones
        </h6>
      </li>

      <li v-if="user?.role === ROLES.ADMIN || user?.role === ROLES.SUPERVISOR" class="nav-item">
        <sidenav-item to="/profile" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Usuarios'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user?.role === ROLES.ADMIN || user?.role === ROLES.SUPERVISOR" class="nav-item">
        <sidenav-item to="/parametros-cotizador" :class="getRoute() === 'parametros-cotizador' ? 'active' : ''"
          navText="Parametros Cotizador">
          <template v-slot:icon>
            <i class="ni ni-settings-gear-65 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user?.role === ROLES.ADMIN || user?.role === ROLES.SUPERVISOR" class="nav-item">
        <sidenav-item to="/configuracion/catalogos" :class="getRoute() === 'configuracion' ? 'active' : ''"
          navText="Catálogos">
          <template v-slot:icon>
            <i class="ni ni-collection text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="user?.role === ROLES.ADMIN || user?.role === ROLES.SUPERVISOR" class="nav-item">
        <sidenav-item to="/configuracion/logs" :class="getRoute() === 'configuracion' ? 'active' : ''"
          navText="Logs de Auditoría">
          <template v-slot:icon>
            <i class="ni ni-badge text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>





      <li class="mt-3 nav-item">
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          حسابي
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 sidenav-title">
          Mi Cuenta
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item to="/perfil" :class="getRoute() === 'perfil' ? 'active' : ''"
          :navText="isRTL ? 'ملفي الشخصي' : 'Mi Perfil'">
          <template v-slot:icon>
            <i class="ni ni-circle-08 text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item mt-3">
        <div class="nav-link d-flex align-items-center cursor-pointer text-danger" @click="logout" style=" margin-left: 17px;">
          <i class="ni ni-button-power text-danger text-sm"></i>
          <span class="nav-link-text">
            {{ isRTL ? 'تسجيل الخروج' : 'Cerrar Sesión' }}
          </span>
        </div>
      </li>
    </ul>
  </div>


</template>
<style scoped>
.sidenav-title {
  transition: opacity 0.2s ease;
}

/* Sidebar minimizado de Argon */
.g-sidenav-hidden .sidenav-title {
  opacity: 0;
  visibility: hidden;
  height: 0;
  overflow: hidden;
  margin: 0;
}

#sidenav-collapse-main {
  overflow-x: hidden;
}
</style>